import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Días sin ir al baño aunque comiste "bien" y tomaste agua', 'Panza dura a la derecha que no baja aunque hagas dieta', 'El laxante que ya no hace efecto si no subís la dosis', 'Ganas que aparecen pero el cuerpo no puede terminar de soltar', 'Fatiga, niebla mental y piel opaca que nadie conecta con el intestino', 'Años buscando soluciones que solo funcionan mientras las hacés'];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-154">
      {/* Subtle background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-red-900/5 to-transparent pointer-events-none" data-id="element-155" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-156">
        <div className="max-w-4xl mx-auto" data-id="element-157">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-158">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 font-[Poppins,_sans-serif]" data-id="element-159">
              ¿Cuántos años más vas a estar así?
            </h2>
            <p className="text-xl text-gray-300 mb-4" data-id="element-160">
              Sos una mujer inteligente. Ya probaste de todo.
            </p>
            <p className="text-lg text-gray-400 mb-2" data-id="element-161">
              Salvado, ciruelas, sen, laxantes… todo funcionó a medias o dejó de
              funcionar. Y el consejo de "comé fibra y tomá agua" no cambió
              nada.
            </p>
            <p className="text-xl text-brand-light font-medium mt-6 mb-4" data-id="element-162">
              Nada de eso falló por culpa tuya.
            </p>
            <p className="text-[20px] font-[500] text-[#22C55E]" data-id="element-163">
              No es falta de voluntad. Es falta de un sistema.
            </p>
          </motion.div>

          <div className="grid gap-4 md:gap-6 mb-16" data-id="element-164">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-[#2a0a0a] p-5 rounded-xl border border-red-900/80" data-id="element-165">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-166" />
                <p className="text-lg text-gray-200" data-id="element-167">{point}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-168">
            <h3 className="text-2xl md:text-4xl font-bold text-brand-gold italic font-[Inter,_sans-serif]" data-id="element-169">
              ¿Y si este fuera el último día que vivís así?
            </h3>
          </motion.div>
        </div>
      </div>
    </section>;
}